module.exports = __webpack_public_path__ + "media/A7.c187d1ad.mp3";